module.exports = __webpack_public_path__ + "img/nobleriding_main_02.97a32fe4.jpg";